let slideUp = (target, duration=500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      //alert("!");
    }, duration);
  }

  let slideDown = (target, duration=500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
      display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
  var slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
      return slideDown(target, duration);
    } else {
      return slideUp(target, duration);
    }
  }

var _navbar_dropdown = document.querySelector('.navbar-dropdown')
var _toggle = document.querySelector('.dropdown-toggle')
var _dropdown = document.querySelector('.dropdown')
var _open = document.querySelector('.header__user-icon')
var _login = document.querySelector('.header-login-btn')

_toggle.addEventListener('click', function () {
  if (!_dropdown.classList.contains('active')) {
    slideDown(_dropdown, 300);
    _toggle.classList.add('active')
    _dropdown.classList.add('active')
  } else {
    slideUp(_dropdown, 300)
    _toggle.classList.remove('active')
    _dropdown.classList.remove('active')
  }
})

_login.addEventListener('click',function () {
    _dropdown.classList.add('active-login')
})

window.addEventListener('click',function (e) {
  var target = e.target
  if (!_navbar_dropdown.contains(e.target)){
    _dropdown.classList.remove('active-login')
    _toggle.classList.remove('active')
    _dropdown.classList.remove('active')
    slideUp(_dropdown, 300)
    _open.setAttribute('aria-expanded', 'false')
  }
})

_open.addEventListener('click',function () {
  if (this.getAttribute('aria-expanded') === "false") {
    _open.setAttribute('aria-expanded', 'true')
    slideDown(_dropdown, 300);
    _toggle.classList.add('active')
    _dropdown.classList.add('active')
  } else {
    _open.setAttribute('aria-expanded', 'false')
    _toggle.classList.remove('active')
    _dropdown.classList.remove('active')
    slideUp(_dropdown, 300);
  }
})
